import { useQuery } from '@apollo/client';
import { graphql } from '../gql';

export const GET_BROKER_AGENCY_ENTITY = graphql(`
  query getBrokerAgencyEntity($uuid: String!) {
    entity(uuid: $uuid) {
      uuid
      referenceId
      type
      submissionType
      agency
      createdAt
      updatedAt
      status
    }
  }
`);

export function useBrokerAgencyEntityQuery(uuid: string) {
  const { loading, error, data } = useQuery(GET_BROKER_AGENCY_ENTITY, {
    variables: {
      uuid: uuid,
    },
  });

  return {
    error,
    loading,
    data,
  };
}
